<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title28"></a>
<div class="verse"><span>From then on, strange things happened to me.</span></div>
<div class="source"><span>—Paul Auster, <i>Moon Palace</i></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429975346_epi01.vue?32045a15